var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.177246 0.659912L9.74264 10.6202V20.3507L14.6032 16.2025V10.6989L24.0192 0.659912H0.177246ZM11.011 10.6202V10.0787L10.6407 9.69471L3.22425 1.97099H21.0215L13.6956 9.78332L13.3364 10.164V10.6989V15.5823L11.011 17.5694V10.6202Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.177246 0.659912L9.74264 10.6202V20.3507L14.6032 16.2025V10.6989L24.0192 0.659912H0.177246ZM11.011 10.6202V10.0787L10.6407 9.69471L3.22425 1.97099H21.0215L13.6956 9.78332L13.3364 10.164V10.6989V15.5823L11.011 17.5694V10.6202Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5574 -9.1853H-8.3374V30.2183H32.5574V-9.1853Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ebcd24e40bbc8c018559e997714b76c1.svg";
export { ForwardRef as ReactComponent };